import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// fuel_types — ประเภทเชื้อเพลิง
// ============================================================================
export const fuelTypes = sqliteTable("fleet_fuel_types", {
  id: text("id").primaryKey(), // ULID
  name: text("name").notNull(),
  nameTh: text("name_th"),
  isActive: integer("is_active").notNull().default(1),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type FuelType = typeof fuelTypes.$inferSelect;
export type NewFuelType = typeof fuelTypes.$inferInsert;
